import React, { useState, useEffect } from "react";
import { Row, Modal, Spinner, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import { API_URL } from "../../services/APIRoute";
import { commonservices } from "../../services/CommonServices";
import { useDispatch } from "react-redux";
import { WorkflowScheduleMachineLogGetList, WorkflowScheduleMachineLogGetListByWorkflowulogid } from "../../services/ReduxTookit/Slice/AllLogRedux";
import Nodata from "./Nodata";
import downloadIcon from "../../assets/images/download.svg";

function WorkFlowMachineLogDetailModal(props) {
    const toUtcDayStartIso = (date) => {
        const value = new Date(date);
        if (Number.isNaN(value.getTime())) return "";

        return new Date(
            Date.UTC(
                value.getFullYear(),
                value.getMonth(),
                value.getDate(),
                0,
                0,
                0,
                0
            )
        ).toISOString();
    };

    const toUtcDayEndIso = (date) => {
        const value = new Date(date);
        if (Number.isNaN(value.getTime())) return "";

        return new Date(
            Date.UTC(
                value.getFullYear(),
                value.getMonth(),
                value.getDate(),
                23,
                59,
                59,
                999
            )
        ).toISOString();
    };

    let dispatch = useDispatch();
    const [WorkflowMachineloglist, setWorkflowMachineloglist] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [downloadingId, setDownloadingId] = useState("");

    const isWithinTwoDays = (dateValue) => {
        if (!dateValue) return false;
        const logDate = moment(dateValue);
        if (!logDate.isValid()) return false;
        return moment().diff(logDate, "hours") <= 48;
    };

    const shouldShowDownload = (item) => {
        const runDate = item?.endon || item?.starton;
        return isWithinTwoDays(runDate);
    };

    const getFileNameFromDisposition = (contentDisposition, fallbackMachineName) => {
        if (!contentDisposition) {
            return `machine-log-${fallbackMachineName || "data"}-${moment().format("YYYYMMDDHHmmss")}.log`;
        }

        const match = contentDisposition.match(/filename="?([^\";]+)"?/i);
        if (match && match[1]) {
            return match[1];
        }

        return `machine-log-${fallbackMachineName || "data"}-${moment().format("YYYYMMDDHHmmss")}.log`;
    };

    async function fnDownloadMachineLog(item) {
        if (!item?.workflowname || !item?.machinename) return;

        const key = `${item?.workflowschedulemachinelogid || ""}-${item?.machineid || ""}`;
        setDownloadingId(key);

        try {
            const formData = new FormData();
            formData.append("folder", item.workflowulogid);
            formData.append("machine_name", item.log_file_name?.includes("-Loop-0.log") ? item.workflowmachinename + "-Loop-0" : item.workflowmachinename);

            const response = await fetch(`${API_URL.BASEURL}${API_URL.GET_MACHINE_LOG_STREAM}`, {
                method: "POST",
                headers: {
                    accept: "*/*",
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    Authorization: `Bearer ${localStorage.getItem("Token") || ""}`,
                    requesturl: window.location.origin,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Unable to download machine log.");
            }

            const blob = await response.blob();
            const fileName = getFileNameFromDisposition(
                response.headers.get("content-disposition"),
                item.machinename
            );

            const fileUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(fileUrl);
        } catch (error) {
        } finally {
            setDownloadingId("");
        }
    }

    async function fnWorkflowMachineLoggetlist() {
        setLoading(true);
        const today = moment();
        const year = today.year();
        const month = today.month();
        const formattedStartDate = toUtcDayStartIso(new Date(year, month, 1));
        const formattedEndDate = toUtcDayEndIso(today.toDate());

        if (props.id && parseInt(props.id) > 0) {
            let body = {
                workflowschedulelogid: parseInt(props.id),
                startdate: formattedStartDate,
                enddate: formattedEndDate,
            };

            dispatch(WorkflowScheduleMachineLogGetList(body)).then((res) => {
                if (res?.payload?.isValidate) {
                    let sorted_array = [...res?.payload?.data?.data?.dataList1]?.sort(
                        (a, b) => a.starton - b.starton
                    );

                    setWorkflowMachineloglist(sorted_array);
                    setLoading(false);
                } else {
                    setWorkflowMachineloglist([]);
                    setLoading(false);
                }
            });
        }
        else if (props.workflowulogid) {
            let body = {
                workflowulogid: props.workflowulogid
            };

            dispatch(WorkflowScheduleMachineLogGetListByWorkflowulogid(body)).then((res) => {
                if (res?.payload?.isValidate) {
                    let sorted_array = [...res?.payload?.data?.data?.dataList1]?.sort(
                        (a, b) => a.starton - b.starton
                    );

                    setWorkflowMachineloglist(sorted_array);
                    setLoading(false);
                } else {
                    setWorkflowMachineloglist([]);
                    setLoading(false);
                }
            });
        }


    }

    useEffect(() => {
        fnWorkflowMachineLoggetlist();
    }, []);
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            fullscreen
            className="normal-modal log-modal workflow-model model-dimension"
        >
            <Modal.Header closeButton className="workflow-log">
                <Modal.Title id="contained-modal-title-vcenter">
                    Workflow Machine Log
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="table-wrapper-main table-wrapper-main-without-border machine-log">
                    {Loading ? (
                        <div>
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) : WorkflowMachineloglist.length > 0 ? (
                        WorkflowMachineloglist?.map((item, index) => {
                            const rowKey = `${item?.workflowschedulemachinelogid || index}-${item?.machineid || "machine"}`;

                            return (
                                <React.Fragment key={rowKey}>
                                    <Row>
                                        <Col xl={6} className="workflow-log-head">
                                            {commonservices.makeMachineDisplayName(
                                                item?.machinename,
                                                0,
                                                item?.assemblyname,
                                                item?.workflowmachinename
                                            )}
                                            {/*<div className="titlebg">{item?.machinename}{item?.assemblyname && item?.workflowmachinename ? item?.workflowmachinename.toUpperCase().replace(item?.assemblyname.toUpperCase(), "").length > 0 ? "-" + item?.workflowmachinename.toUpperCase().replace(item?.assemblyname.toUpperCase(), "") : "" : ""}</div>*/}
                                        </Col>
                                        <Col xl={2} className="workflow-log-head">
                                            <div className="d-flex titlebg">
                                                <div className="ms-3 titlebg">
                                                    {commonservices.getTimeInFormat(item?.starton)}
                                                </div>
                                                <div className="ms-3 titlebg">
                                                    {item?.status !== "start"
                                                        ? commonservices.getTimeInFormat(item?.endon)
                                                        : ""}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xl={2} className="workflow-log-head">
                                            <div className="ms-3 titlebg">
                                                {item?.status !== "start"
                                                    ? String(
                                                        commonservices.calculateDuration(
                                                            item?.starton,
                                                            item?.endon
                                                        )
                                                    )
                                                    : ""}
                                            </div>
                                        </Col>
                                        <Col xl={2} className="workflow-log-head">
                                            <div className="ms-3 titlebg d-flex align-items-center">
                                                {commonservices.getStatusUI(item?.status)}
                                                {shouldShowDownload(item) && (
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip id={`download-tooltip-${rowKey}`}>Download data</Tooltip>}
                                                    >
                                                        <span
                                                            className="ms-2 cursor-pointer"
                                                            onClick={() => fnDownloadMachineLog(item)}
                                                        >
                                                            {downloadingId === rowKey ? (
                                                                <Spinner animation="border" size="sm" role="status" />
                                                            ) : (
                                                                <img
                                                                    src={downloadIcon}
                                                                    alt="download"
                                                                    style={{ width: "16px", height: "16px" }}
                                                                />
                                                            )}
                                                        </span>
                                                    </OverlayTrigger>
                                                )}
                                            </div>
                                        </Col>

                                        <div className="workflow-log-content">
                                            {item.logdata ? (
                                                <ul className="ps-4">
                                                    {item.logdata
                                                        .split("\n")
                                                        .map((text, index) =>
                                                            text ? <pre key={index}>{text}</pre> : null
                                                        )}
                                                </ul>
                                            ) : null}
                                        </div>
                                    </Row>
                                </React.Fragment>
                            )
                        })
                    ) : (
                        <tr>
                            <td colSpan="7" style={{ textAlign: "center" }}>
                                <Nodata />
                            </td>
                        </tr>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default WorkFlowMachineLogDetailModal;
